export const en = {
  undoChanges: 'Undo the recent changes to the task description',
  descriptionBlank:
    'Task description cannot be left blank, please add a description.',
  show: 'Show full description...',
  hide: 'Hide...'
};

export type Translations = typeof en;
